import axios from 'axios';
import {post_request} from "../axiosFun"

//区域列表
export const get_region_list = (params) => {
    params = {
        row:{
            name:params.name,
            head:params.head,
            page_no:params.page,
            page_size:params.limit
        }
    }
    return post_request("/web/area/get_list",params)
};
//人员列表
export const get_customer_users_list = (params) => {
    params = {
        row:{
            
        }
    }
    return post_request("/web/area/customer_users",params)
};
// //添加区域
// export const get_region_add = (params,guardian) => {
//     params = {
//         row:{
//             name:params.name,
//             head:params.head,
//             guardian:guardian,
//             remark:params.remark || ''
//         }
//     }
//     return post_request("/web/area/add",params)
// };
//获取单条区域信息
export const get_region_one= (params) => {
    params = {
        row:{
            id:params
        }
    }
    return post_request("/web/area/get_one",params)
};
//编辑区域信息
export const get_region_edit = (params,guardian) => {
    params = {
        row:{
            id:params.id,
            head:params.head,
            guardian:guardian,
        }
    }
    return post_request("/web/area/edit",params)
};
//删除区域
// export const get_del_area = (params) => {
//     params = {
//         row:{
//             id:params
//         }
//     }
//     return post_request("/web/area/del_area",params)
// };


// WEBPACK FOOTER //
// ./src/api/region/region.js